/**
 * 組織の形（型）の文言。
 *
 * DB14 は 二極型／集中型／分散型／中間型／判定不可 の5つしか持たない。
 * 象限分布による統一判定では「同系統型」と「中心集中型」が加わるため、
 * DB14 と同じ体裁・同じ文言ルールで2件を用意する。
 *   - 断定を避け「〜しやすい」「〜傾向があります」で止める
 *   - 型に優劣をつけない（強みを述べてから、気をつける点を添える）
 *   - 4軸の値そのものを改善目標にしない
 *
 * DB化するときは DB14 に 14-型-同系統 などとして移す。
 * 既存の4つは DB14 から引くので、ここには置かない。
 */
import type { OrgShapeV3 } from './orgShapeV3';

export interface ShapeText {
  id: string;
  本文: string;
  /** 型の3択カードに出す短い説明 */
  note: string;
}

/** DB14 に無い型だけを持つ。既存の型は DB14 の 14-型-* を使う。 */
export const SHAPE_TEXT_EXTRA: Partial<Record<OrgShapeV3, ShapeText>> = {
  同系統型: {
    id: '14-型-同系統',
    本文: '同系統型です。ダイヤモンドで隣り合う2つの持ち味に寄っています。近い考え方どうしなので話が噛み合いやすい一方、反対側にあたる観点が議論に出てきにくくなりやすい傾向があります。',
    note: '隣り合う2つに寄っている',
  },
  中心集中型: {
    id: '14-型-中心集中',
    本文: '中心集中型です。突出した持ち味を持つ方が少なく、全体が中央に集まっています。どの観点もひととおり押さえられる一方、強く推し進める場面や、思い切った決断が出にくくなりやすい傾向があります。',
    note: '中央に集まっている',
  },
};

/** 型の3択カードに出す短い説明（DB14にある型のぶん）。 */
export const SHAPE_NOTE: Record<OrgShapeV3, string> = {
  二極型: '向かい合う2つに分かれている',
  同系統型: '隣り合う2つに寄っている',
  集中型: '1つの持ち味に集まっている',
  分散型: '4つに散らばっている',
  中心集中型: '中央に集まっている',
  中間型: '大きな偏りはない',
};

/** DB14 のエントリID（既存の4つ）。 */
export const SHAPE_DB_ID: Partial<Record<OrgShapeV3, string>> = {
  二極型: '14-型-二極',
  集中型: '14-型-集中',
  分散型: '14-型-分散',
  中間型: '14-型-中間',
};
